import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AdvertisingUpdateUseCaseInterface } from 'domain/usecases';

export class RemoteAdvertisingUpdate
  implements AdvertisingUpdateUseCaseInterface
{
  constructor(private readonly url: string, private readonly httpClient) {}

  async execute(
    params: AdvertisingUpdateUseCaseInterface.Params
  ): Promise<AdvertisingUpdateUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url:
        this.url +
        `/${params.organizationHashId}/advertisement/${params.advertisementID}`,
      body: {
        ...params,
        organizationHashId: undefined,
        advertisementID: undefined,
      },
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
